import { useEffect, useState } from "react";
import { Flex, Text } from "@chakra-ui/react";
import InputComp from "components/InputComp";
import { api } from "services/api";
import { toaster } from "components/ui/toaster";
import ButtonComp from "components/Button";

function Notify({ itemData, setIsOpen, type, setIsLoading }) {
  // const navigate = useNavigate();
  // const [isLoading, setIsLoading] = useState(false);

  // office
  const [message, setMessage] = useState("");

  // customer
  const [forename, setForename] = useState("");
  const [surname, setSurname] = useState("");
  // const [title, setTitle] = useState("");
  const [mobile, setMobile] = useState();

  const [claimtotal, setClaimtotal] = useState(itemData?.claimtotal);
  const [repairsrequired, setRepairsrequired] = useState(
    itemData?.repairsrequired
  );
  // setFailurecause
  const [failurecause] = useState(itemData?.failurecause);

  const [coverItem, setCoverItem] = useState("");
  const [customerQuotes, setCustomerQuotes] = useState("");
  const [recommen, setRecommen] = useState("");
  const [reapairalr, setReapairalr] = useState("");

  // acmanger
  const [policynumber, setPolicynumber] = useState("");
  const [companyname, setCompanyname] = useState("");
  const [covername, setCovername] = useState("");
  const [datereg, setDatereg] = useState("");
  const [mileageatclaim, setMileageatclaim] = useState("");
  const [claimnumber, setClaimnumber] = useState("");

  const onClickSave = async () => {
    setIsLoading(true);
    let res;
    if (type === "office") {
      res = await api.sentClaimnotifyOffice({
        claimid: itemData?.claimid,
        // stateid: 27,
        description: message,
        claimnumber: itemData?.claimnumber,
      });
    } else if (type === "customer") {
      res = await api.sentClaimnotifyCustomer({
        claimid: itemData?.claimid,
        // stateid: 30,
        mobile: mobile,
        description: message,
        type: "mobile",
        company: itemData?.companyname,
        claimnumber: itemData?.claimnumber,
      });
    } else {
      res = await api.sentClaimnotifyAcmanager({
        claimid: itemData?.claimid,
        companyname: itemData?.companyname,
        policynumber: itemData?.policynumber,
        dateclaim: itemData?.dateclaim,
        claimadmin: itemData?.claimadmin,
        claimnumber: itemData?.claimnumber,
        claimtotal: claimtotal,
        repairsrequired: repairsrequired,
        failurecause: failurecause,
        coverItem: coverItem,
        customerQuotes: customerQuotes,
        recommen: recommen,
        reapairalr: reapairalr,
        description: "",
        // stateid: '',
      });
    }

    console.log("resss", res);

    setIsLoading(false);
    if (res.status === 200) {
      setIsOpen(false);
    }
    toaster.create({
      title: res?.response?.data?.message || res?.data?.message || res?.message,
      type: res?.status === 200 ? "success" : "error",
    });
  };

  const getCutomerData = async () => {
    setIsLoading(true);
    return api
      .getClaimCustomer({
        claimid: itemData?.claimid,
      })
      .then((res) => {
        setIsLoading(false);
        console.log("getCutomerData", res);

        if (res.status === 200) {
          setForename(res?.data?.forename || "");
          setSurname(res?.data?.surname || "");
          // setTitle(res?.data?.title || "");
          setMobile(res?.data?.mobile || "");
        } else {
          toaster.create({
            title: res?.data?.message || res?.message,
            type: res?.status === 200 ? "success" : "error",
          });
        }
      });
  };

  const getClaimNotifyAcmanger = async () => {
    setIsLoading(true);
    return api
      .getClaimNotifyAcmanger({
        claimid: itemData?.claimid,
      })
      .then((res) => {
        setIsLoading(false);
        console.log("getClaimNotifyAcmanger", res);

        if (res.status === 200) {
          setPolicynumber(res?.data?.policynumber || "");
          setCompanyname(res?.data?.companyname || "");
          setCovername(res?.data?.covername || "");
          setDatereg(res?.data?.datereg || "");
          setMileageatclaim(res?.data?.mileageatclaim || "");
          setClaimnumber(res?.data?.claimnumber || "");

          setClaimtotal(claimtotal);
          setRepairsrequired(failurecause + " " + repairsrequired);
          // setCoverItem
          // setCustomerQuotes
          // setRecommen
          // setReapairalr
        } else {
          toaster.create({
            title: res?.data?.message || res?.message,
            type: res?.status === 200 ? "success" : "error",
          });
        }
      });
  };

  useEffect(() => {
    console.log("Notify useEffect ()", {
      type,
      itemData,
    });

    if (type === "customer") {
      getCutomerData();
    } else if (type === "office") {
    } else {
      getClaimNotifyAcmanger();
    }

    // const itemDataDemo = {
    //   claimid: 6159,
    //   claimadmin: "Chris Lawson",
    //   state: 18,
    //   adminresponded: true,
    //   paiddate: null,
    //   claimnumber: "AUCLM6096",
    //   policynumber: "EY14CDV1",
    //   policyid: 30250,
    //   companyname: "Affordable cars",
    //   statename: "Awaiting Diagnosis",
    //   dateclaim: "2021-06-10T18:30:00.000Z",
    //   claimdateseconds: "3706257456",
    //   failedpart: "",
    //   failedarea: "",
    //   failurecause: "",
    //   repairsrequired:
    //     "Quote Required.\n10.39 quote received\n12.37 This one can be rejected please, the part wouldn’t be covered but I was also at the site when this customer came in she’d had a crash and the airbag light often then comes on a few weeks later. \n\n",
    //   claimtotal: 0,
    //   represponded: null,
    // };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (type === "office") {
    return (
      <Flex direction={"column"} overflow={"hidden"} gap={"1rem"}>
        <InputComp
          type={"textarea"}
          label={"Message"}
          value={message}
          onChange={setMessage}
          keyname={"w-100"}
        />

        <ButtonComp
          onClick={onClickSave}
          bg={"primary"}
          // w={"12rem"}
          alignSelf={"flex-end"}
          label="Send"
          keyname="submit"
        />
      </Flex>
    );
  }

  if (type === "customer") {
    return (
      <Flex overflow={"hidden"} direction={"column"} gap={"1rem"}>
        {forename || surname ? (
          <Text>{`Name: ${forename} ${surname}`}</Text>
        ) : null}
        <InputComp
          label={"Mobile"}
          type={"tel"}
          value={mobile}
          onChange={setMobile}
          keyname={"w-100"}
        />

        <InputComp
          type={"textarea"}
          label={"Message"}
          value={message}
          onChange={setMessage}
          keyname={"w-100"}
        />

        <ButtonComp
          onClick={onClickSave}
          bg={"primary"}
          // w={"12rem"}
          alignSelf={"flex-end"}
          label="Send"
          keyname="submit"
        />

        {/* </Flex> */}
      </Flex>
    );
  }

  return (
    <Flex overflow={"hidden"} direction={"column"} gap={"1rem"}>
      {/* <Modal
        isopen={isModalOpen}
        type="table"
        items={claimHisData}
        title={"Claim History"}
        setIsOpen={setIsModalOpen}
      /> */}
      {/* <Flex width={"100%"} flexFlow={"wrap"} gap={"3"} alignItems={"center"}> */}
      {/* <SimpleGrid
          columns={ismobile ? 1 : 1}
          maxWidth={"25rem"}
          columnGap="2rem"
          rowGap="2"
        > */}

      {itemData?.adminresponded ? (
        <Text fontWeight={"bold"} color={"red"}>
          Admin has responded
        </Text>
      ) : null}

      <InputComp
        label={"Registration"}
        value={policynumber}
        disabled={true}
        keyname={"w-100"}
      />

      <InputComp
        label={"Dealer"}
        value={companyname}
        disabled={true}
        keyname={"w-100"}
      />
      <InputComp
        label={"Policy coverage"}
        value={covername}
        disabled={true}
        keyname={"w-100"}
      />

      <InputComp
        label={"Policy created date"}
        type={"date"}
        value={datereg}
        disabled={true}
        keyname={"w-100"}
      />
      {/* todo: missing */}
      <InputComp
        label={"Claims handle"}
        // value={claimadmin}
        disabled={true}
        keyname={"w-100"}
      />

      <InputComp
        label={"Mileage"}
        value={mileageatclaim}
        disabled={true}
        keyname={"w-100"}
      />

      <InputComp
        label={"Claim reference"}
        value={claimnumber}
        disabled={true}
        keyname={"w-100"}
      />

      <InputComp
        label={"Total cost of bill"}
        value={claimtotal}
        onChange={setClaimtotal}
        type={"number"}
        keyname={"w-100"}
      />

      <InputComp
        type={"textarea"}
        label={"Fault / repair needed"}
        value={repairsrequired}
        onChange={setRepairsrequired}
        keyname={"w-100"}
      />

      <InputComp
        type={"textarea"}
        label={"Is it a covered item?"}
        value={coverItem}
        onChange={setCoverItem}
        keyname={"w-100"}
      />

      <InputComp
        type={"textarea"}
        label={"Are these customer quotes or our quotes ?"}
        value={customerQuotes}
        onChange={setCustomerQuotes}
        keyname={"w-100"}
      />

      <InputComp
        type={"textarea"}
        label={"Office recommendation"}
        value={recommen}
        onChange={setRecommen}
        keyname={"w-100"}
      />

      <InputComp
        type={"textarea"}
        label={"Have the reapir already been completed?"}
        value={reapairalr}
        onChange={setReapairalr}
        keyname={"w-100"}
      />

      <ButtonComp
        label="Send to Rep"
        keyname="submit"
        onClick={onClickSave}
        alignSelf={"flex-end"}
      />

      {/* </Flex> */}
    </Flex>
  );
}

export default Notify;
